var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("10、一子每月享一千，多个子女皆可享。（猜一个个税专项附加扣除项目）")])])
}]

export { render, staticRenderFns }